import { Link } from "react-router-dom";
import { ArrowRight, CircleCheck, Facebook, Instagram, Youtube } from "lucide-react";
import { APP_ROUTES } from "../../routes/AppRoutes";
import heroCutout from "../../assets/images/whatwedo/eventsExperiences/events.jpg";
import heroBg from "../../assets/images/whatwedo/eventsExperiences/eventsExperiencesBg.jpg";

const POINTS = [
  "Production, vendors and logistics under one team",
  "Artists, celebrities and creators on the guest list",
  "Photos and videos captured on the day, ready to post",
];

const SOCIALS = [
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/profile.php?id=61571039155522" },
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/hkiofficial" },
  { icon: Youtube, label: "YouTube", href: "https://www.youtube.com/@Hki_music" },
];

const EventsHero = () => {
  return (
    <section className="ee-hero">
      {/* Stage photo, colour blob, outlined word and performer. */}
      <div className="ee-hero-visual" aria-hidden="true">
        <div className="ee-hero-bg" style={{ backgroundImage: `url(${heroBg})` }} />
        <div className="ee-hero-blob" />
        <span className="ee-hero-word">Events</span>
        <img className="ee-hero-cutout" src={heroCutout} alt="" />
      </div>

      <div className="ee-hero-card" data-aos="fade-right" data-aos-once="true">
        <span className="ee-hero-card-kicker">Events &amp; Experiences</span>
        <h1 className="ee-hero-card-title">
          You bring the occasion. <span>We run the event.</span>
        </h1>
        <p className="ee-hero-card-lead">Production, vendors, talent and content, under one team.</p>
        <p className="ee-hero-card-desc">
          Brand launches, movie premieres, conferences, live shows and activations. We run it all,
          from production and vendors to the final load-out.
        </p>
        <ul className="ee-checks">
          {POINTS.map((point) => (
            <li key={point}>
              <CircleCheck size={16} /> {point}
            </li>
          ))}
        </ul>
        <Link to={APP_ROUTES.CONTACT_US} className="ee-btn">
          Contact Us <ArrowRight size={16} />
        </Link>
      </div>

      <div className="ee-hero-bar">
        <div className="ee-hero-socials">
          {SOCIALS.map(({ icon: Icon, label, href }) => (
            <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label}>
              <Icon size={16} />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventsHero;
